import { Pipe } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: 'safeHtml' })
export class SafeHtmlPipe {
  constructor(private sanitizer:DomSanitizer){}

  public transform(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/safe-html/safe-html.pipe.ts